import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BasicCallout } from '@flightstats/component-lib';
import componentBase from '../../../src/lib/component-base';
import FSFlatButton from '../../../src/components/lib/FSFlatButton';
import { openTab } from '../../../src/utils/openTab';

@componentBase('BasicCalloutWrapper')
export default class BasicCalloutWrapper extends Component {
  openURLHandler = (link, label, openNewTab) => (
    (e) => {
      if (openNewTab) {
        openTab(link, e);
        this.context.reportButtonPress(label);
      } else {
        this.context.goto(link, label);
      }
    }
  );

  render = () => {
    const {
      bulletText,
      buttonLabel,
      icon,
      onClickURL,
      onClickGALabel,
      openNewTab,
      subText,
      titleText,
    } = this.props;

    return (
      <BasicCallout
        bulletText={bulletText}
        icon={icon}
        title={titleText}
        text={subText}
        button={
          <FSFlatButton
            label={buttonLabel}
            backgroundColor='rgb(109,216,54)'
            hoverColor='#64bc23'
            style={{ width: '100%', minWidth: '240px' }}
            onClick={this.openURLHandler(onClickURL, onClickGALabel, openNewTab)}
          />
        }
      />
    );
  };
}

BasicCalloutWrapper.propTypes = {
  bulletText: PropTypes.arrayOf(PropTypes.string),
  buttonLabel: PropTypes.string,
  icon: PropTypes.string,
  subText: PropTypes.string,
  titleText: PropTypes.string,
  onClickURL: PropTypes.string,
  onClickGALabel: PropTypes.string,
  openNewTab: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./shared/components/BasicCalloutWrapper/BasicCalloutWrapper.js